"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgWorkshopMode = function (props) { return ((0, jsx_runtime_1.jsxs)("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [(0, jsx_runtime_1.jsx)("path", { d: "M5.289 6.242a.704.704 0 00-.705.694v11.807c0 .38.32.695.705.695h11.973a.704.704 0 00.704-.695V12.84c0-.432.355-.781.792-.781.438 0 .793.35.793.78v5.904c0 1.243-1.029 2.257-2.29 2.257H5.29C4.029 21 3 19.986 3 18.743V6.936C3 5.693 4.028 4.68 5.289 4.68h5.687c.438 0 .792.35.792.782a.787.787 0 01-.792.78H5.289z" }), (0, jsx_runtime_1.jsx)("path", { d: "M7.47 13.718v2.253c0 .207.166.37.376.37h2.285a.355.355 0 00.263-.11l8.207-8.086-2.818-2.78-8.2 8.086a.362.362 0 00-.112.267zm13.31-7.722a.73.73 0 000-1.045l-1.758-1.734a.756.756 0 00-1.06 0l-1.375 1.356 2.818 2.78 1.375-1.357z" })] }))); };
exports.default = SvgWorkshopMode;
